import React from 'react';
import { View, StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';
import { DisplayText, BodyText } from '../Text';
import { BackButton } from '../BackButton';

export const MobileHeader = ({
  title,
  subtitle,
  onClose,
}: MobileHeaderProps) => {
  return (
    <View testID="sg-mobile-header">
      {onClose ? (
        <BackButton
          icon="IconClose"
          containerStyle={styles.closeButton}
          onPress={onClose}
        />
      ) : null}
      {title ? (
        <DisplayText
          size={3}
          style={[styles.title, !subtitle && styles.margin]}
        >
          {title}
        </DisplayText>
      ) : null}
      {subtitle ? (
        <BodyText
          size={4}
          style={[styles.subtitle, Boolean(subtitle) && styles.margin]}
        >
          {subtitle}
        </BodyText>
      ) : null}
    </View>
  );
};

type MobileHeaderProps = {
  readonly title?: string;
  readonly subtitle?: string;
  readonly onClose?: () => void;
};

const styles = StyleSheet.create({
  closeButton: {
    paddingBottom: theme.spacing.xlarge - theme.spacing.xsmall,
    alignSelf: 'flex-end',
  },
  title: {
    fontSize: 32,
    paddingVertical: theme.spacing.small,
  },
  subtitle: {
    paddingVertical: theme.spacing.small,
  },
  margin: {
    marginBottom: theme.spacing.large + theme.spacing.small,
  },
});
